<template>
  <v-app>
    <div id="app">
      <v-system-bar
        color="#ffe761"
        height="30px"
        class="system-bar"
        v-if="currentUser && activeFeeSession && !activeFeeSession.active"
        app
      >
        <v-spacer></v-spacer>
        <span class="black--text"
          ><b
            >You have selected a non-current fee session year
            <span class="red--text">({{ activeFeeSession.title }})</span>. Make
            sure you
            <a @click="revertFeeSession" class="blue--text"
              >change it back.</a
            ></b
          ></span
        >
        <v-spacer></v-spacer>
      </v-system-bar>

      <NavigationDrawer v-if="currentUser && !currentInstitution.is_super_institution && !currentInstitution.stage" />
      
      <AppBar
        :isLoading="isLoading"
        v-if="currentUser && currentInstitution"
        :isSuperInstitution="currentInstitution.is_super_institution"
      />
      
      <v-main>
        <!-- <div color="#f6f6f6">  -->
        <Breadcrumbs class="mb-2" v-if="currentUser || $route.path.startsWith('/help')"/>
        <!-- <transition name="fade" mode="out-in"> -->
        <transition name="slide-fade" mode="out-in">
          <router-view class="view" />
        </transition>
      </v-main>

      <!-- disabled user dialog -->
      <v-dialog v-if="currentUser" v-model="currentUser.disabled" persistent width="400">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2 red--text">
            Account Disabled
          </v-card-title>
          <v-card-text class="mt-2 font-weight-bold">
            <div v-if="currentUser.is_admin">
              <p class="ma-0 text-caption">
                Your account has been disabled.
              </p>
            </div>
            <div v-else>
              Your account has been disabled. Please contact the school admin.
            </div>
          </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn
              color="red"
              outlined
              small
              @click="window.location.reload();"
            >
              <v-icon>mdi-reload</v-icon>
              Check again 
            </v-btn>
            <v-btn v-if="currentUser.is_admin" small @click="showSupportSheet = true" color="primary" outlined>Contact Support</v-btn>

          <v-spacer></v-spacer>
        </v-card-actions>
        </v-card>
      </v-dialog>


      <!-- disabled institution dialog -->
      <v-dialog v-if="currentUser && currentInstitution" v-model="currentInstitution.disabled" persistent width="400">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2 red--text">
            Institution Disabled
          </v-card-title>
          <v-card-text class="mt-2 py-0 font-weight-bold">
            <div v-if="currentUser.is_admin">
              <p class="mb-0 text-caption">
                Your institution has been disabled.
              </p>
            </div>
            <div v-else>
              <p class="mb-0">
                Your institution has been disabled. Please contact the school admin.
              </p>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              outlined
              small
              @click="window.location.reload();"
            >
              <v-icon>mdi-reload</v-icon>
              Check again 
            </v-btn>
              <v-btn v-if="currentUser.is_admin" small @click="showSupportSheet = true" color="primary" outlined>Contact Support</v-btn>
              <!-- <v-btn v-if="currentUser.is_admin" small color="primary" outlined>Contact Support</v-btn> -->
            
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- contact support sheet -->
    <v-bottom-sheet
      scrollable
      persistent
      :width="$vuetify.breakpoint.mdAndDown ? '100%' : '50%'"
      :value="showSupportSheet"
      @click:outside="showSupportSheet = false"
    >
      <v-card>
        <v-card-title class="pb-2">
          Contact Support<v-spacer></v-spacer>

          <v-btn icon @click="showSupportSheet = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <div class="mb-4">
          <v-list-item href="tel:+917900087696">
            <v-list-item-avatar><v-icon>mdi-phone</v-icon></v-list-item-avatar>
            <v-list-item-title class="text-left">+91 79000 87696</v-list-item-title>
            <v-list-item-action
              ><v-icon>mdi-arrow-right</v-icon></v-list-item-action
            >
          </v-list-item>
          <v-list-item href="tel:+919082573219">
            <v-list-item-avatar><v-icon>mdi-phone</v-icon></v-list-item-avatar>
            <v-list-item-title class="text-left">+91 90825 73219</v-list-item-title>
            <v-list-item-action
              ><v-icon>mdi-arrow-right</v-icon></v-list-item-action
            >
          </v-list-item>
          <!-- <v-list-item href="tel:+918149640459">
            <v-list-item-avatar><v-icon>mdi-phone</v-icon></v-list-item-avatar>
            <v-list-item-title>+91 81496 40459</v-list-item-title>
            <v-list-item-action
              ><v-icon>mdi-arrow-right</v-icon></v-list-item-action
            >
          </v-list-item> -->
        </div>
      </v-card>
    </v-bottom-sheet>


    </div>
  </v-app>
</template>
<script>
import NavigationDrawer from "@components/widgets/NavigationDrawer.vue";
import AppBar from "@components/widgets/AppBar.vue";

import api from "@api/index";
import endpoints from "@api/repository";
import Breadcrumbs from "@components/widgets/Breadcrumbs";
// import TourHelper from "@utils/tour_helper";
import { mapGetters, mapActions } from "vuex";

export default   {
  name: "App",
  data: () => ({
    // drawer: null,
    // fee_sessions: [],
    flag: 0,
    showSupportSheet: false,
    window

  }),
  computed: {
    ...mapGetters([
      "accessToken",
      "currentUser",
      "currentInstitution",
      "isLoading",
      "feeSessionData",
      "activeFeeSession",
      "tourFlags",
    ]),
    essentials() {
      return {
        setLoading: this.setLoading,
        accessToken: this.accessToken,
        handleErrorsFunction: (err) => {
          this.setLoading(false);
          console.log(err);
        },
      };
    },
  },
  components: {
    NavigationDrawer,
    AppBar,
    Breadcrumbs,
  },


  methods: {
    ...mapActions([
      "setLoading",
      "setCurrentUser",
      "setCurrentInstitution",
      "setFeeSessionData",
      "setActiveSessionData",
      "setTourFlags",
    ]),
    // get new data from server
    async updateCurrentUserDetails() {
      var response;
      response = await api.handleApi({
        apiEssentials: this.essentials,
        url: endpoints.getMyDetails,
        responseVar: response,
      });

      if (response != null) {
        this.setCurrentUser(response);
      }
    },
    async updateCurrentInstitutionDetails() {
      if (this.currentInstitution) {
        var response;
        response = await api.handleApi({
          apiEssentials: this.essentials,
          url:
            endpoints.getInstitutionDetailsById +
            (this.currentInstitution ? this.currentInstitution.id : 0) +
            "/",
          responseVar: response,
        });

        if (response != null) {
          this.setCurrentInstitution(response);
        }
      }
    },

    async updateFeeSessionData() {
      var url = endpoints.getFeeSessions;

      var fee_sessions = await api.call(this.essentials, url);
      this.setFeeSessionData(fee_sessions);
    },

    revertFeeSession() {
      localStorage.removeItem("activeFeeSession");

      var active_session = this.feeSessionData.find(
        (session) => session.active == true
      );
      this.setActiveSessionData(active_session);
      window.location.reload();
    },

  },
  watch: {
    $route(to) {
      if (this.currentInstitution) {
        document.title =
          ` ${to.meta.title} | ${this.currentInstitution.name} ` || "";
      } else document.title = to.meta.title;
    },
  },
  async created() { 
    if(this.currentInstitution) {
      if(this.currentInstitution.stage == 1) {
        this.$router.push({ name: 'ModulesSetup' })
      }
      else if(this.currentInstitution.stage == 2) {
        this.$router.push({ name: 'ClassroomSetup' })
      }
      else if(this.currentInstitution.stage == 3) {
        this.$router.push({ name: 'StudentsSetup' })
      }
      else if(this.currentInstitution.stage == 4) {
        this.$router.push({ name: 'StaffSetup' })
      }
    }
    if(this.currentUser) 
      await this.updateCurrentUserDetails();

    await this.updateCurrentInstitutionDetails();
    
    if (this.currentUser) {
      this.updateFeeSessionData();
    }
  },
};
</script>


<style>
@import "~shepherd.js/dist/css/shepherd.css";
@import url("https://fonts.googleapis.com/css2?family=Montserrat&display=swap");

.shepherd-element {
  margin: 5px !important;
  font-family: "Montserrat", sans-serif;
}
.shepherd-text {
  margin: 10px 0px !important;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* background-color: #F6F6F6; */
  /* background-image: url('https://cdn.vuetifyjs.com/images/parallax/material.jpg'); */
}
span.required::after {
  content: "*";
  font-size: 18px;
  color: red;
}
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
.rounded-input {
  border-radius: 12px !important;
}
@media print {
  .system-bar {
    display: none;
  }
}

/* Stripped Data table Rows 
tbody tr:nth-of-type(odd) {
   background-color: #f8f8f8;
   
 } */

/* tbody tr:hover {
   background-color: red !important;
   
 } */
</style>
